import * as cn from 'classnames'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import MenuButton, { MenuButtonState } from 'components/features/pfm/MenuButton/MenuButton'
import { OuterEventTrackerContext, OuterEventTrackerContextType } from 'components/utils/OuterEventTracker'
import * as styles from 'components/features/external/ExternalNavigation/ExternalNavigation.styl'
import withContext from 'hocs/withContext/withContext'
import { HeaderTheme } from 'interfaces/component'
import { PureComponent } from 'react'
import { RouteComponentProps } from 'react-router'
import { ABOUT_URL, COACH_URL, FEED_POSTS_URL } from 'tangle-shared'

export type ExternalNavigationStateProps = {
  currentUrl: string
}
export type ExternalNavigationOwnProps = RouteComponentProps & {
  theme: HeaderTheme
}

type ExternalNavigationContextProps = {
  outerEventTracker: OuterEventTrackerContextType
}

type ExternalNavigationProps =
  & ExternalNavigationStateProps
  & ExternalNavigationOwnProps
  & ExternalNavigationContextProps

type ExternalNavigationState = {
  menuState: MenuButtonState
}

class ExternalNavigation extends PureComponent<ExternalNavigationProps, ExternalNavigationState> {
  state: ExternalNavigationState = {
    menuState: 'hamburger',
  }

  private menuButtonNode: HTMLDivElement | null = null

  render () {
    const { menuState } = this.state
    const className = cn(styles.externalNavigation, {
      [styles.opened]: this.isMenuOpened(),
      [styles.light]: this.props.theme === 'light',
    })

    return (
      <nav className={ className }>
        <div className={ styles.menuButton } ref={ (node) => this.menuButtonNode = node }>
          <MenuButton state={ menuState } onClick={ this.handleMenuClick } />
        </div>
        <ul className={ styles.list }>
          <li className={ this.getClassNameByUrl(ABOUT_URL) }>
            <NavigationLink className={ styles.navigationLink } to='about'>
              About
            </NavigationLink>
          </li>
          <li className={ this.getClassNameByUrl(FEED_POSTS_URL) }>
            <NavigationLink className={ styles.navigationLink } to='feedposts'>
              Feed
            </NavigationLink>
          </li>
          <li className={ this.getClassNameByUrl(COACH_URL) }>
            <NavigationLink className={ styles.navigationLink } to='coaching'>
              Coaching
            </NavigationLink>
          </li>
          {/* <li className={ this.getClassNameByUrl(CREDIT_CARD_URL) }>
            <NavigationLink className={ styles.navigationLink } to='card'>
              Card
            </NavigationLink>
          </li> */}
        </ul>
      </nav>
    )
  }

  componentDidMount () {
    const { outerEventTracker } = this.props
    outerEventTracker.addOuterEventListener('click', this.handleOuterClick, this.menuButtonNode)
    outerEventTracker.addOuterEventListener('keydown', this.handleOuterKeyDown, null)
    outerEventTracker.addOuterEventListener('scroll', this.handleOuterScroll, null)
  }

  componentWillUnmount () {
    const { outerEventTracker } = this.props
    outerEventTracker.removeOuterEventListener('click', this.handleOuterClick)
    outerEventTracker.removeOuterEventListener('keydown', this.handleOuterKeyDown)
    outerEventTracker.removeOuterEventListener('scroll', this.handleOuterScroll)
  }

  private openMenu () {
    this.setState({ menuState: 'cross' })
  }

  private closeMenu () {
    this.setState({ menuState: 'hamburger' })
  }

  private isMenuOpened () {
    return this.state.menuState === 'cross'
  }

  private getClassNameByUrl (url: string) {
    return cn(styles.listItem, {
      [styles.selected]: this.props.currentUrl === url,
    })
  }

  private handleMenuClick = () => {
    if (this.isMenuOpened()) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  private handleOuterScroll = () => {
    this.closeMenu()
  }

  private handleOuterClick = () => {
    if (!this.isMenuOpened()) {
      return
    }
    this.closeMenu()
  }

  private handleOuterKeyDown = ({ key }: KeyboardEvent) => {
    if (key !== 'Escape') {
      return
    }
    this.closeMenu()
  }
}

export default withContext(OuterEventTrackerContext, 'outerEventTracker')(ExternalNavigation)
